import React from 'react';
import LazyImage from './LazyImage';

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  sizes?: string;
  priority?: boolean;
}

const OptimizedImage: React.FC<OptimizedImageProps> = ({ 
  src, 
  alt, 
  className = '',
  sizes = '(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw',
  priority = false 
}) => {
  // Generate responsive image URLs (you can implement actual resizing service later)
  const generateSrcSet = (baseSrc: string) => {
    // For now, we'll use the same image but you can implement
    // image resizing service or generate multiple sizes
    return `${baseSrc} 1x`;
  };

  if (priority) {
    // For critical images (hero section), load immediately
    return (
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover ${className}`}
        sizes={sizes}
        srcSet={generateSrcSet(src)}
        loading="eager"
      />
    );
  }

  return (
    <LazyImage
      src={src}
      alt={alt}
      className={className}
    />
  );
};

export default OptimizedImage;